"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrderColumnMigration", {
    enumerable: true,
    get: function() {
        return OrderColumnMigration;
    }
});
const _common = require("@nestjs/common");
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _cache = /*#__PURE__*/ _interop_require_default(require("~/utils/cache"));
const _utils = require("~/utils");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _ProjectMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-mgr/v2/ProjectMgrv2"));
const _getUniqueName = require("~/helpers/getUniqueName");
const _getColumnPropsFromUIDT = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnPropsFromUIDT"));
const _columnsservice = require("~/services/columns.service");
const _Upgrader = /*#__PURE__*/ _interop_require_default(require("~/Upgrader"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
const PARALLEL_LIMIT = +process.env.NC_ORDER_MIGRATION_PARALLEL_LIMIT || 10;
const TEMP_TABLE = 'nc_temp_processed_order_models';
const propsByClientType = {};
const sql = {
    mysql2: `UPDATE ?? SET ?? = ROW_NUMBER() OVER (ORDER BY ?? ASC)`,
    pg: `UPDATE ?? t SET ?? = s.rn FROM (SELECT ??, ROW_NUMBER() OVER (ORDER BY ?? ASC) rn FROM ??) s WHERE t.?? = s.??`,
    sqlite3: `WITH rn AS (SELECT ??, ROW_NUMBER() OVER (ORDER BY ?? ASC) rn FROM ??) UPDATE ?? SET ?? = (SELECT rn FROM rn WHERE rn.?? = ??.??)`
};
const memoizedGetColumnPropsFromUIDT = async (source)=>{
    const clientType = source.type;
    if (!propsByClientType[clientType]) {
        propsByClientType[clientType] = await (0, _getColumnPropsFromUIDT.default)({
            uidt: _nocodbsdk.UITypes.Order,
            column_name: 'nc_order',
            title: 'nc_order'
        }, source);
    }
    return propsByClientType[clientType];
};
let OrderColumnMigration = class OrderColumnMigration {
    logExecutionTime(message, hrTime, force = false) {
        if (!force && !this.logTimes) return;
        const [seconds, nanoseconds] = process.hrtime(hrTime);
        // reset hrTime
        hrTime = process.hrtime();
        const elapsedSeconds = seconds + nanoseconds / 1e9;
        this.log(`${message} in ${elapsedSeconds}s`);
    }
    async job() {
        if (!await _Noco.default.ncMeta.knexConnection.schema.hasTable(TEMP_TABLE)) {
            await _Noco.default.ncMeta.knexConnection.schema.createTable(TEMP_TABLE, (table)=>{
                table.increments('id').primary();
                table.string('fk_model_id').notNullable();
                table.boolean('completed').defaultTo(false);
                table.text('error').nullable();
                table.index('fk_model_id');
            });
        }
        // Remove incomplete models from previous run
        await _Noco.default.ncMeta.knexConnection(TEMP_TABLE).delete().where('completed', false);
        // Reset processed models count
        this.processingModels = [
            {
                fk_model_id: 'placeholder',
                processing: true
            }
        ];
        this.processedModelsCount = 0;
        // Clear cache
        this.cache.clear();
        const ncMeta = new _Upgrader.default();
        try {
            var _this;
            ncMeta.enableUpgraderMode();
            const totalHrTime = process.hrtime();
            const numberOfModelsToBeProcessed = +((_this = await ncMeta.knexConnection(_globals.MetaTable.MODELS).join(_globals.MetaTable.SOURCES, `${_globals.MetaTable.MODELS}.source_id`, '=', `${_globals.MetaTable.SOURCES}.id`).where(`${_globals.MetaTable.MODELS}.mm`, false).where((builder)=>{
                builder.where(`${_globals.MetaTable.SOURCES}.is_meta`, true);
                builder.orWhere({
                    is_local: true
                });
            }).whereNotIn(`${_globals.MetaTable.MODELS}.id`, ncMeta.knexConnection(TEMP_TABLE).select('fk_model_id')).count('*', {
                as: 'count'
            }).first()) == null ? void 0 : _this.count);
            const wrapper = async (model)=>{
                try {
                    await this.processModel(model, ncMeta);
                } catch (e) {
                    this.log(`Error processing model ${model.id}:`);
                    console.error(e);
                    await this.updateModelStatus(_Noco.default.ncMeta, model.id, false, e.message);
                } finally{
                    const item = this.processingModels.find((m)=>m.fk_model_id === model.id);
                    if (item) {
                        item.processing = false;
                    }
                    this.processedModelsCount++;
                    this.log(`Processed ${this.processedModelsCount} of ${numberOfModelsToBeProcessed} models`);
                }
            };
            const queue = new _pqueue.default({
                concurrency: PARALLEL_LIMIT
            });
            // eslint-disable-next-line no-constant-condition
            while(true){
                if (queue.pending > PARALLEL_LIMIT * 2) {
                    await new Promise((resolve)=>setTimeout(resolve, 1000));
                    continue;
                }
                this.processingModels = this.processingModels.filter((m)=>m.processing);
                const models = await this.getModelsQuery(ncMeta);
                if (!(models == null ? void 0 : models.length)) break;
                const processModels = models.splice(0);
                for (const model of processModels){
                    this.processingModels.push({
                        fk_model_id: model.id,
                        processing: true
                    });
                    queue.add(()=>wrapper(model)).catch((e)=>{
                        this.log(`Error processing model ${model.fk_model_id}`);
                        console.error(e);
                    });
                }
            }
            await queue.onIdle();
            // TODO: Drop temp table manually for now
            // await ncMeta.knexConnection.schema.dropTableIfExists(TEMP_TABLE);
            await ncMeta.disableUpgraderMode();
            this.logExecutionTime('Migration job completed', totalHrTime, true);
            return true;
        } catch (error) {
            this.log('Migration failed:');
            console.error(error);
            await ncMeta.disableUpgraderMode();
            return false;
        }
    }
    async populateOrderValues(dbDriver, tnPath, model, source, newColumn) {
        var _model_primaryKeys_;
        const aiColumn = model.columns.find((c)=>c.ai);
        const pkColumn = (_model_primaryKeys_ = model.primaryKeys[0]) == null ? void 0 : _model_primaryKeys_.column_name;
        if (aiColumn) {
            const q = dbDriver.raw(`UPDATE ?? SET ?? = ??`, [
                tnPath,
                newColumn.column_name,
                aiColumn.column_name
            ]);
            source.upgraderQueries.push(q.toQuery());
            const createIndexQuery = dbDriver.raw(`CREATE INDEX ?? ON ?? (??)`, [
                `${model.table_name}_order_idx`,
                tnPath,
                `${newColumn.column_name}`
            ]);
            source.upgraderQueries.push(createIndexQuery.toQuery());
            return;
        }
        if (!pkColumn) return;
        const params = {
            mysql2: [
                tnPath,
                newColumn.column_name,
                pkColumn
            ],
            pg: [
                tnPath,
                newColumn.column_name,
                pkColumn,
                pkColumn,
                tnPath,
                pkColumn,
                pkColumn
            ],
            sqlite3: [
                pkColumn,
                pkColumn,
                tnPath,
                tnPath,
                newColumn.column_name,
                pkColumn,
                tnPath,
                pkColumn
            ]
        };
        const q = dbDriver.raw(sql[source.type], params[source.type]);
        source.upgraderQueries.push(q.toQuery());
        const createIndexQuery = dbDriver.raw(`CREATE INDEX ?? ON ?? (??)`, [
            `${model.table_name}_order_idx`,
            tnPath,
            `${newColumn.column_name}`
        ]);
        source.upgraderQueries.push(createIndexQuery.toQuery());
    }
    async addOrderColumn(model, source, sqlMgr) {
        const newColumn = _extends({}, await memoizedGetColumnPropsFromUIDT(source), {
            column_name: (0, _getUniqueName.getUniqueColumnName)(model.columns, 'nc_order'),
            title: (0, _getUniqueName.getUniqueColumnAliasName)(model.columns, 'nc_order'),
            cdf: null,
            system: true,
            altered: _columnsservice.Altered.NEW_COLUMN
        });
        const tableUpdateBody = _extends({}, model, {
            tn: model.table_name,
            originalColumns: model.columns.map((c)=>_extends({}, c, {
                    cn: c.column_name
                })),
            columns: [
                ...model.columns,
                newColumn
            ].map((c)=>_extends({}, c, {
                    cn: c.column_name
                }))
        });
        await sqlMgr.sqlOpPlus(source, 'tableUpdate', tableUpdateBody);
        return newColumn;
    }
    async processModel(modelData, ncMeta) {
        const { id: modelId, source_id, base_id } = modelData;
        const context = {
            workspace_id: modelData == null ? void 0 : modelData.fk_workspace_id,
            base_id
        };
        try {
            const hrtime = process.hrtime();
            const originalSource = await this.cache.get(source_id, async ()=>_models.Source.get(context, source_id));
            if (!originalSource || !originalSource.isMeta()) {
                return;
            }
            const source = new _models.Source(_extends({}, originalSource, {
                upgraderMode: true,
                upgraderQueries: []
            }));
            source.upgraderMode = true;
            const dbDriver = await _NcConnectionMgrv2.default.get(source);
            const model = await _models.Model.get(context, modelId);
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                model,
                source,
                dbDriver
            });
            await model.getColumns(context);
            const tnPath = baseModel.getTnPath(model.table_name);
            const sqlMgr = _ProjectMgrv2.default.getSqlMgr(context, {
                id: source.base_id
            }, ncMeta);
            let orderColumn = model.columns.find((c)=>c.uidt === _nocodbsdk.UITypes.Order);
            if (!orderColumn) {
                orderColumn = await this.addOrderColumn(model, source, sqlMgr);
                this.logExecutionTime(`Add order column query generated`, hrtime);
                await _models.Column.insert(context, _extends({}, orderColumn, {
                    system: true,
                    fk_model_id: model.id,
                    source_id
                }), ncMeta);
                this.logExecutionTime(`Add order column meta query generated`, hrtime);
                await this.populateOrderValues(dbDriver, tnPath, model, source, orderColumn);
                this.logExecutionTime(`Populate order values query generated`, hrtime);
            } else {
                this.log(`Order column already exists for model ${modelId}, Table: ${model.table_name}, BaseId ${base_id}${context.workspace_id ? `, WorkspaceId ${context.workspace_id}` : ''}`);
                await this.updateModelStatus(_Noco.default.ncMeta, modelId, true);
                return;
            }
            // Add update model status query to upgrader queries
            await this.updateModelStatus(ncMeta, modelId, true);
            const realDbDriver = await _NcConnectionMgrv2.default.get(new _models.Source(_extends({}, source, {
                upgraderMode: false
            })));
            const queries = source.upgraderQueries.splice(0);
            if (_utils.isEE) {
                await realDbDriver.raw(queries.join(';'));
            } else {
                const trans = await realDbDriver.transaction();
                try {
                    for (const query of queries){
                        await trans.raw(query);
                    }
                    await trans.commit();
                } catch (e) {
                    await trans.rollback();
                    throw e;
                }
            }
            await ncMeta.runUpgraderQueries();
        } catch (error) {
            throw error;
        }
    }
    getModelsQuery(ncMeta) {
        return ncMeta.knexConnection(_globals.MetaTable.MODELS).select([
            `${_globals.MetaTable.MODELS}.id`,
            'source_id',
            `${_globals.MetaTable.MODELS}.base_id`,
            ..._utils.isEE ? [
                `${_globals.MetaTable.MODELS}.fk_workspace_id`
            ] : []
        ]).where(`${_globals.MetaTable.MODELS}.mm`, false).join(_globals.MetaTable.SOURCES, `${_globals.MetaTable.MODELS}.source_id`, '=', `${_globals.MetaTable.SOURCES}.id`).where((builder)=>{
            builder.where(`${_globals.MetaTable.SOURCES}.is_meta`, true);
            builder.orWhere({
                is_local: true
            });
        }).whereNotIn(`${_globals.MetaTable.MODELS}.id`, ncMeta.knexConnection(TEMP_TABLE).select('fk_model_id')).whereNotIn(`${_globals.MetaTable.MODELS}.id`, this.processingModels.map((m)=>m.fk_model_id)).orderBy(`${_globals.MetaTable.MODELS}.source_id`).limit(PARALLEL_LIMIT * 10);
    }
    async updateModelStatus(ncMeta, modelId, status, error) {
        await ncMeta.knexConnection(TEMP_TABLE).insert({
            fk_model_id: modelId,
            completed: status,
            error
        });
    }
    constructor(){
        this.debugLog = (0, _debug.default)('nc:migration-jobs:order-column');
        this.log = (...msgs)=>console.log('[nc_job_005_order_column]: ', ...msgs);
        this.processingModels = [
            {
                fk_model_id: 'placeholder',
                processing: true
            }
        ];
        this.processedModelsCount = 0;
        this.cache = new _cache.default(1000);
        this.logTimes = process.env.NC_ORDER_MIGRATION_LOG_TIMES === 'true';
    }
};
OrderColumnMigration = _ts_decorate([
    (0, _common.Injectable)()
], OrderColumnMigration);
